import { render } from "./JobApplication.vue?vue&type=template&id=5603b371&scoped=true"
import script from "./JobApplication.vue?vue&type=script&lang=js"
export * from "./JobApplication.vue?vue&type=script&lang=js"

import "./JobApplication.vue?vue&type=style&index=0&id=5603b371&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5603b371"]])

export default __exports__